<script>
import EventLocationAndTime from "@/components/events/EventLocationAndTime.vue";
import EventMap from "@/components/events/EventMap.vue";
import EventSignup from "@/components/events/EventSignup.vue";
import EventSchedule from "@/components/events/EventSchedule.vue";

export default {
  name: "UpcomingEventDetails",
  components: {EventSchedule, EventSignup, EventMap, EventLocationAndTime},
  props: ["event"],
}
</script>

<template>
<div>
  <event-location-and-time :event="event" />
  <event-schedule :schedule="event.Programm" v-if="event.Programm.length > 0" />
  <event-signup :event-id="event.id" :signed-up="event.Angemeldet" />
  <event-map v-if="event.Adresse.Ort !== 'Online'" :event="event" />
</div>
</template>

<style scoped>

</style>